// 工作流类型
export enum EWorkflowType {
  /// <summary>
  /// 下发
  /// </summary>
  Issue = 10,

  /// <summary>
  /// 变更
  /// </summary>
  Change = 11,

  /// <summary>
  /// 回执
  /// </summary>
  Receipt = 20,

  /// <summary>
  /// 已审回执
  /// </summary>
  AuditedReceipt = 21,

  /// <summary>
  /// 过程调度
  /// </summary>
  ProcessSchedule = 50,
}